/**
 * Validação de email no frontend
 */
export const isValidEmail = (email: string): boolean => {
    if (!email || typeof email !== 'string') {
        return false;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
};

/**
 * Normaliza email removendo espaços
 */
export const normalizeEmail = (email: string): string => {
    return email.trim().toLowerCase();
};

